import React from "react";
// import { SvgIcon } from "@mui/material";
// import svg logo
import Logo from "../../images/svg/logo.inline.svg";
import { Typography } from "@mui/material";

const IconCompanyLogo = (props) => {
  const { style } = props;
  //   return <Typography>asdasd</Typography>;
  return <img src={Logo} style={{ ...style }} {...props} />;
  //   return <Logo />; //{...props} style={{ cursor: "pointer", ...style }} />;
};
export default IconCompanyLogo;
